<template>
  <div class="main bgc-fff c-333 fs-18 ff-as">
    <div class="banner p-r">
      <div class="banner-img bgs-cover"></div>
      <div class="banner-text p-a c-c m-a ta-c c-fff">
        <h1 class="m-0 fs-50">Precision Agriculture</h1>
        <div class="c-ddd lh-15 fs-26"></div>
      </div>
    </div>
    <!-- banner:end -->
    <section class="area-1 pl-60 pr-60 ta-c">
      <div class="c-59 lh-15">
        From GPS guidance technology, auto steering for tractors, to precision farming system, <br />
        we have precision agriculture solutions to streamline your day-to-day work to increase efficiency and
        profitability.
      </div>
    </section>
    <!-- area-1:end -->
    <!-- <section class="area-2 area-2-product product-mod pl-60 pr-60">
      <h2 class="m-0 fs-40 c-26 ta-c fw-500">— Precision Agriculture —</h2>
      <ul class="d-f jc-c ta-c">
        <li>
          <nuxt-link class="li-a" to="/product/autosteeringkit">
            <h3 class="">Autosteering Kit</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="Autosteering Kit"
                src="@/assets/images/agriculture_solution/area_2_1.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
        <li>
          <nuxt-link class="li-a" to="/product/al01-3d-land-leveling-system">
            <h3 class="">AL01 3D Land Leveling System</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="AL01 3D Land Leveling System"
                src="@/assets/images/industry/3D-land-leveling-system.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
      </ul>
    </section> -->
    <section class="area-2 area-2-product product-mod pl-60 pr-60">
      <h2 class="m-0 fs-40 c-26 ta-c">— Precision Agriculture —</h2>
      <ul class="d-f jc-c ta-c">
        <li>
          <a class="li-a" href="/product/fjd-connect">
            <h3 class="">FJD Connect <br />Farm Management Platform</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="FJD Connect"
                v-lazy="require('@/assets/images/agriculture_solution/Farm-anagement-System.png')"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>

        <li>
          <a class="li-a" href="/product/autosteeringkit">
            <h3 class="">FJD AT1 <br />Autosteering Kit</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="Autosteering Kit"
                v-lazy="require('@/assets/images/agriculture_solution/area_2_1.png')"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
        <li>
          <a class="li-a" href="/product/al01-3d-land-leveling-system">
            <h3 class="">FJD AL01 <br />3D Land Leveling System</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="AL01 3D Land Leveling System"
                v-lazy="require('@/assets/images/industry/3D-land-leveling-system.png')"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
      </ul>
    </section>
    <!-- area-2:end -->
    <!-- <section class="area-3 product-mod">
      <h2 class="m-0 fs-40 c-26 ta-c fw-500">— AG Machinery —</h2>
      <ul class="d-f jc-sb ta-c">
        <li>
          <nuxt-link class="li-a" to="/product/tractor">
            <h3 class="">Ragnar R70</h3>
            <i class="reveal"
              ><img width="100%" height="100%" alt="Ragnar R70" src="@/assets/images/agriculture_solution/r70.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
        <li>
          <nuxt-link class="li-a" to="/product/wheeledtractor">
            <h3 class="">Ragnar R160</h3>
            <i class="reveal"
              ><img width="100%" height="100%" alt="Ragnar R160" src="@/assets/images/agriculture_solution/r160.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
        <li>
          <nuxt-link class="li-a" to="/product/wheeledtractor2204">
            <h3 class="">Ragnar R180</h3>
            <i class="reveal"
              ><img width="100%" height="100%" alt="Ragnar R180" src="@/assets/images/agriculture_solution/r180.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
      </ul>
    </section> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .product-mod .more b {
    transition: transform 0.3s;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23262626' stroke-linecap='round' stroke-linejoin='round' d='M4.5 10l4-4-4-4' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  /* pc端样式 */
  @media screen and (min-width: 768px) {
    .main {
      margin-top: 3.958vw;
    }

    /* banner */
    .banner-img {
      padding-top: 3.6rem;
      background-image: url('@/assets/images/business/p2-d.jpg');
      background-position: center;
    }
    /* .banner-text{width:52.0833vw; top:50%;} */
    .banner-text {
      display: block;
      /* width: 52.0833vw;
    top: 50%;
    left: 15.1vw;
    text-align: left;
    transform: translate(0, -50%); */
    }
    .banner-text h1 {
      margin-bottom: 15px;
    }
    /* area-1 */
    .area-3,
    .area-4 {
      padding-top: 1rem;
    }
    .area-1 {
      padding: 0.48rem 18.75vw 0.8rem 18.75vw;
    }
    .area-1 li i {
      width: 5.2083vw;
      height: 5.2083vw;
      display: block;
      margin: 0 auto 15px;
    }
    .area-1 ul {
      padding: 5.625vw 20px 0;
    }

    /* area-2 / area-3 */
    .product-mod h2 {
      margin-bottom: 3.281vw;
    }
    /* .product-mod li{width:30.208vw;padding:2.39vw 0 2.08vw; background-color: #FAFAFA; } */
    .product-mod li {
      width: 5.92rem;
      height: 5.6rem;
      padding: 0.62rem 0.56rem 0.48rem;
      background-color: #fafafa;
      box-sizing: border-box;
      margin-right: 0.16rem;
    }

    .product-mod li:last-child {
      margin-right: 0;
    }
    .product-mod li i {
      display: block;
      margin-bottom: 0.16rem;
      /* width: 20.8333vw;
    height: 12.917vw; */
      /* margin: 0 auto .4rem; */
    }
    /* .product-mod li h3{height:50px; margin:2.0833vw 0 1.25vw;font-size: 32px;} */
    .product-mod li h3 {
      font-size: 0.28rem;
      font-weight: 500;
      color: #262626;
      /* line-height: .48rem; */
      margin-bottom: 0.16rem;
    }
    .product-mod .li-a {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 4.15rem;
    }
    .product-mod li h3 b {
      display: block;
    }
    .product-mod li span {
      font-size: 0.16rem;
      border: 1px solid #262626;
      margin: 0 auto;
      padding: 0.06rem 0.16rem 0.06rem 0.2rem;
    }
    .product-mod li span em {
      color: #262626;
    }

    .product-mod .more b {
      width: 12px;
      height: 12px;
      margin-left: 5px;
    }
    .product-mod li a:hover b {
      transform: translateX(6px);
    }
    .product-mod li a:hover img {
      transform: scale(1.05);
    }
    .product-mod li img {
      transition: transform 0.3s ease-out;
    }

    /* area-2 */
    .area-2 {
      padding-bottom: 6.25vw;
    }

    /* area-3 */
    .area-3 {
      padding-bottom: 6.25vw;
      padding-left: 2.92vw;
      padding-right: 2.92vw;
    }

    /* area-4 */
    .area-4 {
      padding-bottom: 5.73vw;
    }
    .area-4-text {
      margin: 0 11.99vw 1.417vw;
    }
    .area-4-text h2 {
      margin-bottom: 1.562vw;
    }
    .area-4-mod {
      margin-top: 4.1667vw;
    }
    .area-4-mod-text {
      width: 50%;
    }
    .area-4-mod-text > div {
      padding: 0 9.375vw 0 3.645vw;
    }
    .area-4-mod-img {
      padding-top: 21.875vw;
      width: 50%;
    }

    // .area-4-mod-1 .area-4-mod-img {
    //   background-image: url('../../images/agriculture_solution/area_4_1.jpg');
    // }
    // .area-4-mod-2 .area-4-mod-img {
    //   background-image: url('../../images/agriculture_solution/area_4_2.jpg');
    // }
    // .area-4-mod-3 .area-4-mod-img {
    //   background-image: url('../../images/agriculture_solution/area_4_3.jpg');
    // }
    // .area-4-mod-4 .area-4-mod-img {
    //   background-image: url('../../images/agriculture_solution/area_4_4.jpg');
    // }
    // .area-4-mod-5 .area-4-mod-img {
    //   background-image: url('../../images/agriculture_solution/area_4_5.jpg');
    // }
  }

  /*pc端样式 1440px ~  1650px*/
  @media screen and (max-width: 1650px) and (min-width: 1440px) {
    .fs-50 {
      font-size: 40px;
    }
    .fs-40 {
      font-size: 30px;
    }
    .fs-26 {
      font-size: 24px;
    }
    /* .product-mod li h3 {
    font-size: 24px;
  } */
  }

  /*pc端样式 1200px ~  1440px*/
  @media screen and (max-width: 1440px) and (min-width: 1200px) {
    .fs-50 {
      font-size: 30px;
    }
    .fs-40 {
      font-size: 26px;
    }
    .fs-26 {
      font-size: 20px;
    }
    .banner-text {
      width: 70%;
      top: 50%;
    }
    .area-1 li i {
      width: 80px;
      height: 80px;
    }
    .area-1 li span {
      font-size: 16px;
    }
    /* .product-mod li h3 {
    font-size: 20px;
  } */
    .product-mod li span {
      font-size: 14px;
    }
  }

  /*pc端样式 768px ~  1200px*/
  @media screen and (max-width: 1200px) and (min-width: 768px) {
    .fs-50 {
      font-size: 28px;
    }
    .fs-40 {
      font-size: 24px;
    }
    .fs-26 {
      font-size: 18px;
    }
    .fs-18 {
      font-size: 16px;
    }
    .banner-text {
      width: 90%;
      top: 50%;
    }
    .area-1 li i {
      width: 70px;
      height: 70px;
    }
    .area-1 li span {
      font-size: 16px;
    }
    /* .product-mod li h3 {
    font-size: 18px;
  } */
    .product-mod li span {
      font-size: 14px;
    }
  }
</style>
